import styled from 'styled-components';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { theme } from '@/styles/theme';

const Title = styled.h1`
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: ${theme.fontSizes.xl};
  color: ${theme.colors.text.gray};
  margin-bottom: ${theme.spacing.xxxl};
`;

const Blog = () => {
  return (
    <Section $padding="large">
      <Container>
        <Title>Blog</Title>
        <Subtitle>Coming soon - Insights on vocabulary learning and language mastery</Subtitle>
      </Container>
    </Section>
  );
};

export default Blog;
